import { ReactElement } from 'react';
import './Loading.scss';
import clsx from 'clsx';
import { CircularProgress } from '@mui/material';

interface LoadingProps {
  message?: string;
  className?: string;
}

const Loading = ({ message, className }: LoadingProps): ReactElement => {
  return (
    <div className={clsx('loading', className ? className : '')}>
      <CircularProgress sx={{ color: '#2979FF' }} />
      <h2>{message}</h2>
    </div>
  );
};

export default Loading;
